module.exports = __webpack_public_path__ + "static/media/new-gilbert-couch.95177bed.jpg";